import DeviationPage from './DeviationPage';
import DeviationPageContainer from './DeviationPage.container';

export default DeviationPageContainer(DeviationPage);
